__turbopack_context__.v({
  "ActionButton": "B-SVCW_ActionButton",
  "BeforeLineItems": "B-SVCW_BeforeLineItems",
  "Discount": "B-SVCW_Discount",
  "EventsTitle": "B-SVCW_EventsTitle",
  "ExhibitionName": "B-SVCW_ExhibitionName",
  "GeneralTitle": "B-SVCW_GeneralTitle",
  "Header": "B-SVCW_Header",
  "HeaderWithRemoveAll": "B-SVCW_HeaderWithRemoveAll",
  "Location": "B-SVCW_Location",
  "LocationInfo": "B-SVCW_LocationInfo",
  "MainTitle": "B-SVCW_MainTitle",
  "MinorTitle": "B-SVCW_MinorTitle",
  "OrderContentWrapper": "B-SVCW_OrderContentWrapper",
  "OrderDetails": "B-SVCW_OrderDetails",
  "OrderSummary": "B-SVCW_OrderSummary",
  "SelectTime": "B-SVCW_SelectTime",
  "SelectedDate": "B-SVCW_SelectedDate",
  "SelectedTime": "B-SVCW_SelectedTime",
  "Sticky": "B-SVCW_Sticky",
  "Title": "B-SVCW_Title",
  "UnappliedDiscount": "B-SVCW_UnappliedDiscount",
});
